/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowThread200ResponseDataPostsInnerUser } from './ShowThread200ResponseDataPostsInnerUser';
import {
    ShowThread200ResponseDataPostsInnerUserFromJSON,
    ShowThread200ResponseDataPostsInnerUserFromJSONTyped,
    ShowThread200ResponseDataPostsInnerUserToJSON,
    ShowThread200ResponseDataPostsInnerUserToJSONTyped,
} from './ShowThread200ResponseDataPostsInnerUser';

/**
 * 
 * @export
 * @interface ShowThread200ResponseDataPostsInner
 */
export interface ShowThread200ResponseDataPostsInner {
    /**
     * 
     * @type {number}
     * @memberof ShowThread200ResponseDataPostsInner
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowThread200ResponseDataPostsInner
     */
    forumThreadId?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowThread200ResponseDataPostsInner
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataPostsInner
     */
    body?: string;
    /**
     * 
     * @type {ShowThread200ResponseDataPostsInnerUser}
     * @memberof ShowThread200ResponseDataPostsInner
     */
    user?: ShowThread200ResponseDataPostsInnerUser;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataPostsInner
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataPostsInner
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ShowThread200ResponseDataPostsInner interface.
 */
export function instanceOfShowThread200ResponseDataPostsInner(value: object): value is ShowThread200ResponseDataPostsInner {
    return true;
}

export function ShowThread200ResponseDataPostsInnerFromJSON(json: any): ShowThread200ResponseDataPostsInner {
    return ShowThread200ResponseDataPostsInnerFromJSONTyped(json, false);
}

export function ShowThread200ResponseDataPostsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowThread200ResponseDataPostsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'forumThreadId': json['forum_thread_id'] == null ? undefined : json['forum_thread_id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'body': json['body'] == null ? undefined : json['body'],
        'user': json['user'] == null ? undefined : ShowThread200ResponseDataPostsInnerUserFromJSON(json['user']),
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ShowThread200ResponseDataPostsInnerToJSON(json: any): ShowThread200ResponseDataPostsInner {
    return ShowThread200ResponseDataPostsInnerToJSONTyped(json, false);
}

export function ShowThread200ResponseDataPostsInnerToJSONTyped(value?: ShowThread200ResponseDataPostsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'forum_thread_id': value['forumThreadId'],
        'user_id': value['userId'],
        'body': value['body'],
        'user': ShowThread200ResponseDataPostsInnerUserToJSON(value['user']),
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

